module.exports = __webpack_public_path__ + "img/structure-management-2024.edeeeea1.jpg";